<template>
	<div
		small
		:color="department.active ? 'green' : 'grey'"
		:class="`${childrenCount > 0 ? 'd-block' : 'd-none'} sector-item-wrapper`"
	>
		<div class="sector-title" style="border-left: 20px solid transparent">
			<span style="color: grey">{{ organizationName }}</span> /
			{{ department.name }} ({{ childrenCount }})
			<v-btn icon @click="handleToggleCollapseClick">
				<v-icon v-if="collapsed">keyboard_arrow_down</v-icon>
				<v-icon v-else>keyboard_arrow_right</v-icon>
			</v-btn>
		</div>
		<div
			:style="`display: ${childrenCount > 0 && collapsed ? 'block' : 'none'};`"
		>
			<JobsTreeTeams
				:departmentId="department.id"
				:jobs="jobs"
				@newchild="handleNewChild"
				:organizationName="organizationName"
				:departmentName="department.name"
				:onArchiveJob="onArchiveJob"
				:unfold="unfold"
			></JobsTreeTeams>
		</div>
	</div>
</template>

<script>
import JobsTreeTeams from '../jobsTreeTeams/JobsTreeTeams';

export default {
	name: 'JobsTreeDepartmentItem',
	props: {
		department: {
			type: Object,
		},
		jobs: {
			type: Array,
			required: false,
			default() {
				return [];
			},
		},
		organizationName: {
			type: String,
			required: true,
		},
		onArchiveJob: {
			type: Function,
			required: true,
		},
		unfold: {
			type: Boolean,
			required: true,
		},
	},
	components: {
		JobsTreeTeams,
	},
	data() {
		return {
			childrenCount: 0,
			collapsed: true,
		};
	},
	methods: {
		handleNewChild() {
			this.childrenCount += 1;
			this.$emit('newchild');
		},
		handleToggleCollapseClick() {
			this.collapsed = !this.collapsed;
		},
	},
	watch: {
		jobs: {
			handler: function () {
				this.childrenCount = 0;
			},
			immediate: true,
			deep: true,
		},
		unfold: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.collapsed = newVal;
				}
			},
			immediate: true,
			deep: true,
		},
	},
};
</script>
